'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '& .notification': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#28C887',
    width: '100%',
    marginLeft: '0',
    left: '0'
  },
  '& .message': {
    color: 'white',
    textAlign: 'center'
  },
  '& .text': {
    color: 'white',
    textAlign: 'center'
  },
  '& i': {
    alignSelf: 'flex-end'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var omitCloseIcon = _ref.omitCloseIcon;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _extends3.default)({
    '& .notification': {
      backgroundColor: theme.colors.success
    },
    '& i': {
      display: omitCloseIcon ? 'none' : 'show'
    }
  }, (0, _objectResolvePath2.default)(theme, 'SuccessNotification.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/notifications/SuccessNotification/SuccessNotification.style.js
// module id = 505
// module chunks = 0